/** ********  订单管理 ********* */
// 团队订单类别
export const getTeamTypeList = {
  url: '/admin/common/getCatalogByType.json',
  method: 'get'
};

// 获取团队订单列表
export const getTeamOrderList = {
  url: '/admin/supplier/get_data.json',
  method: 'get'
};

// 订单冻结
export const freezeOrder = {
  url: '/admin/supplier/freezeOrder.json',
  method: 'post'
};

// 获取团队订单详情
export const getOrderDetail = {
  url: '/admin/supplier/getOrderDetail.json',
  method: 'get'
};

// 验证订单是否删除
export const checkOrderIsdelete = {
  url: '/admin/salesmanOrder/checkOrderIsdelete',
  method: 'post'
};

// 导出全部订单

export const exportOrderList = {
  url: '/admin/supplier/exportOrderMainExl.json'
};

// 团队订单汇总列表查询

export const getTeamOrderSummaryList = {
  url: '/admin/salesSummary/getSupplierSummary.json',
  method: 'get'
};

// 导出团队订单汇总
export const exportTeamOrderSummaryList = {
  url: '/admin/salesSummary/exportSupplierSummary.json'
};

// 团队列表查询
export const getSalemanSupplier = {
  url: '/admin/salesSummary/getSalemanSupplier.json',
  method: 'get'
};

// 业务员订单汇总列表查询
export const getSalesmanOrderSummaryList = {
  url: '/admin/salesSummary/getSalesmanSummary.json',
  method: 'get'
};

// 导出业务员订单汇总列表
export const exportSalesmanOrderSummaryList = {
  url: '/admin/salesSummary/exportSalesmanSummary.json'
};

// 获取报单列表
export const getReportList = {
  url: '/admin/thirdBusiness/getDeclarationTable.json',
  method: 'get'
};

// 获取微信保单详情商品清单列表
export const getRepostProdList = {
  url: '/admin/thirdBusiness/getDeclarationProdDetail.json',
  method: 'get'
};
// 获取订单状态list
export const getOrderStateList = {
  url: '/mobile/v2/salesman/getOrderStateList.json',
  method: 'get'
};
// 聚合订单list
export const getOrderGatherList = {
  url: '/admin/supplier/get_data.json',
  method: 'get'
}
// 聚合订单导出
export const orderGatherExport = {
  url: '/admin/supplier/supplierOrderExport.json',
  method: 'post'
}
// 取消订单商品
export const cancelOrders = {
  url: '/admin/supplier/orderCancel.json',
  method: 'post'
}